// @flow

import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

import { MenuPartCategory } from 'PMT/entities/menu';
import MenuPartItemType from 'PMT/entities/menu/MenuPartItemType';
import { Utils } from 'PMT/utils';

import I18n from 'PMT/i18n/I18n';
import Notify from 'PMT/utils/Notify';

import Product from './Product';

const Item = ({ item, menuInfo }) => {
  if (item.isProduct()) {
    const product = menuInfo.restaurantMenu.getProductWithId(item.id);
    if (_.isNull(product)) {
      return null;
    }

    return <Product product={product} menuInfo={menuInfo} />;
  }

  const category = menuInfo.menuPart.getCategoryWithId(item.id);
  if (_.isNull(category)) {
    return null;
  }
  return (
    <MenuPartCategoryView
      category={category}
      menuInfo={{ ...menuInfo, level: menuInfo.level + 1 }}
    />
  );
};

const ItemsList = ({ style, items, menuInfo }) => {
  return (
    <div style={style}>
      {items.map((item, index) => (
        <Item
          key={`${index}_${item.type}_${item.id}`}
          item={item}
          menuInfo={menuInfo}
        />
      ))}
    </div>
  );
};

class MenuPartCategoryView extends React.Component {

  onDeleteCategory = () => {
    Notify.confirm(
      I18n.tr('menu.menu_part.category.delete.are_you_sure'),
      (result: boolean) => {
        if (result) {
          this.props.menuInfo.onDeleteCategory(this.props.menuInfo.menuPart, this.props.category);
        }
      }
    );
  };

  render() {
    const { menuInfo, category, isRoot } = this.props;

    if (category === null) {
      return null;
    }

    return (
      <div>
        <div
          className={classNames('category-header', {
            'is-root': isRoot,
            'is-not-root': !isRoot,
          })}
        >
          {!isRoot && (
            <div>
              {category.name}
              {!_.isEmpty(category.image) &&
                <i className="fa fa-camera" />
              }
              <span
                className="subcategory"
              >
                {I18n.tr('menu.menu_part.category.subcategory')}
              </span>
            </div>
          )}

          <div>
            <button
              className="btn btn-default btn-small"
              onClick={() => menuInfo.onRunAdd(category)}
            >
              {I18n.tr('menu.menu_part.category.modify_items')}
            </button>

            {/* Add new category */}
            <button
              className="btn btn-default btn-small new_category"
              onClick={() => menuInfo.onNewCategory(category)}
            >
              + {I18n.tr('menu.menu_part.category.new_category')}
            </button>

            {!isRoot && (
              <button
                className="btn btn-default btn-small"
                onClick={() => menuInfo.onModifyCategory(category)}
              >
                {I18n.tr('menu.menu_part.category.edit_category')}
              </button>
            )}

            {!isRoot && (
              <button
                className="btn btn-default btn-small"
                onClick={this.onDeleteCategory}
              >
                {I18n.tr('menu.menu_part.category.delete')}
              </button>
            )}
          </div>
        </div>

        <ItemsList
          style={{
            paddingLeft: `${10 * menuInfo.level}px`,
          }}
          items={category.items.filter(item => item.type === MenuPartItemType.CATEGORY)}
          menuInfo={menuInfo}
        />
        <ItemsList
          style={{
            paddingLeft: `${10 * menuInfo.level}px`,
          }}
          items={category.items.filter(item => item.type === MenuPartItemType.PRODUCT)}
          menuInfo={menuInfo}
        />
      </div>
    );
  }
}

MenuPartCategoryView.defaultProps = {
  isRoot: false,
};

export default MenuPartCategoryView;
